<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div v-else style="height: 100%">
        <div class="aba-contrato">
            <loader v-if="isLoading" />
            <div class="vertical-flow">
                <div class="columns">
                    <div class="column is-5">
                        <search-bar :onSearch="debouncedOnSearch" />
                    </div>

                    <div class="column is-3">
                        <vss-select
                            ref="situacaoSelect"
                            :searchable="false"
                            :options="situacaoSelect"
                            v-model="situacaoSelected"
                            mlLabels
                            title="situacao"
                            clearable
                            @input="onSituacaoChanged"
                            :height="40"
                        />
                    </div>

                    <div class="column is-4">
                        <button
                            v-if="permissao.create"
                            class="save-btn botao-acao"
                            type="button"
                            @click="openContrato(null)"
                        >
                            {{ $t('adicionar') }} {{ $t('contrato') }}
                        </button>
                    </div>
                </div>
                <div class="registry-wrapper">
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="contratos"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                            }"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'descricao'">
                                <a @click="openContrato(props.row)">
                                    {{ props.row[f.key] }}
                                </a>
                            </div>
                            <div class v-else-if="f.key == 'tipo-servico'">
                                {{ props.row.tiposervico.descricao }}
                            </div>
                            <div class v-else-if="f.key == 'excluir'">
                                <b-button
                                    v-if="permissao.delete"
                                    class="action-button"
                                    :type="
                                        props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                    "
                                    :icon-right="
                                        props.row['situacao'] == 1 ? 'delete' : 'check'
                                    "
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy 
                                    :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                                />
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                    size="is-medium"
                                >
                                    {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                                </b-tag>
                            </div>

                            <div class="column-data" v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>

        <ContratoManage
            v-model="gerenciar"
            :idcontrato="idcontrato"
            @idcontrato="idcontrato = $event"
            @voltar="closeContrato()"
            @reloadData="carregarDados()"
        />
    </div>
</template>

<script>
import ProContratoService from '@/services/promotor/pro_cliente/ProContratoService.js';
import ContratoManage from '@/components/promotor/cliente/abas/contrato/ContratoManage.vue' 
import Message from '@/models/Message';

export default {
    components: {
        ContratoManage,
        Message,
    },
    data() {
        return {
            contratoservice: new ProContratoService(this.$http, this.$router),
            permissao: false,
            accessDenied: false,
            debouncedOnSearch: null,
            searchQuery: null,
            isEmpty: true,

            contratos: [],
            fields: [
                { key: 'codigo', width: null, sortable: true },
                { key: 'descricao', width: null, sortable: true },
                { key: 'dias', width: null, sortable: true },
                { key: 'horas-dia', width: null, sortable: true },
                { key: 'tipo-servico', width: null, sortable: true },
                { key: 'situacao', width: 80, sortable: true },
                { key: 'excluir', width: 20, sortable: false },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            selected: null,
            idcontrato: 0,
            selectedNome: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                column: 'nome',
                order: 'asc',
            },
            isLoading: false,
            gerenciar: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'clientes');
        if (!this.permissao.read) {
            this.accessDenied = true;
            return;
        }
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        openContrato(contrato) {
            this.idcontrato = contrato != null ? contrato.id : 0;
            this.gerenciar = true;
        },
        closeContrato() {
            this.idcontrato = 0;
            this.gerenciar = false;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.pagination.column = field;
            this.pagination.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.contratoservice
                .findAllByCliente(
                    this.pagination.column,
                    this.pagination.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    +this.$route.params.id,
                    this.searchQuery
                )
                .then(this.mapItemsContrato)
                .then((contracts) => {
                    this.contratos = contracts;
                    this.isEmpty = this.contratos.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar os contratos! ', e);
                    this.$root.msgs.push(new Message('error', 'msg-erro-carregar-contratos', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItemsContrato(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((i) => {
                return {
                    id: i.id,
                    codigo: i.idcontratoerp,
                    descricao: i.descricao,
                    situacao: i.situacao,
                    dias: i.diaspadrao,
                    'horas-dia': i.horasdiapadrao,
                    excluir: 'excluir',
                    contratosInRotas: i.contratosinrotas,
                    tiposervico: i.tiposervico,
                };
            });
        },

        promptChangeSituacao(row) {
            if (row.contratosInRotas > 0 && row.situacao == 1) {
                this.$root.msgs.push(new Message('alert', 'msg-excluir-contrato', true));
                return;
            }
            this.selected = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricao'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacaoContrato(),
            });
        },
        updateSituacaoContrato() {
            let tempFailure = this.$t(
                    this.selected.situacao == 1
                        ? 'msg-erro-ao-reativar-n'
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('contrato') }
                );
            let tempContrato = {
                idcontrato: this.selected.id,
                situacao: this.selected.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;
            this.contratoservice
                .updateSituacao(tempContrato)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('contrato') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.selected = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-contrato {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
